import { ETAT_EN_COURS, ETAT_REALISE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default function genererCritereRecherche() {
  return {
    auto: null,
    societeId: null,
    codes: [],
    etats: [ETAT_EN_COURS, ETAT_REALISE],
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    lieuDelivraisonIds: [],
    clientIds: [],
    dispositifIds: [],
    OtTypeIds: [],
    campagneIds: [],
    materielTypeIds: [],
    enseigneIds: [],
    tagIds: [],
    otTagIds: [],
  };
}
